import { enableProdMode, importProvidersFrom } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { authConfig } from '@app/authentication/auth-config';
import { AuthRequestInterceptor } from '@app/authentication/auth-request.interceptor';
import { httpInterceptorProviders } from '@app/core/interceptors';
import { routes } from '@app/routes';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { AppComponent } from '@src/app/QualityBidders/app.component';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { LausdAppComponent } from './app/LAUSD/app.component';
import { lausdRoutes } from './app/LAUSD/lausd-routes';
import { LausdLoginService } from './app/LAUSD/services/lausd-login.service';
import { LausdNavService } from './app/LAUSD/services/lausd-nav.service';
import { LoginService, NavService } from './app/QualityBidders/services';
import { serviceProvider, siteResource } from './assets/helpers/siteService';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(
  siteResource({
    ca: AppComponent,
    lausd: LausdAppComponent,
  }),
  {
    providers: [
      provideRouter(
        siteResource({ ca: routes, lausd: lausdRoutes }),
        withRouterConfig({
          paramsInheritanceStrategy: 'always',
        })
      ),
      importProvidersFrom(
        BrowserModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatSidenavModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        AuthModule.forRoot(authConfig)
      ),
      httpInterceptorProviders,
      provideEnvironmentNgxMask(),
      {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: {
          floatLabel: 'always',
          appearance: 'outline',
        },
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthHttpInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthRequestInterceptor,
        multi: true,
      },
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      // Add service providers here:
      ...serviceProvider(NavService, {
        lausd: LausdNavService,
        ca: NavService,
      }),
      // Single login implementation for current site (token + alias so inject(LoginService) gets same instance)
      ...serviceProvider(LoginService, {
        lausd: LausdLoginService,
        ca: LoginService,
      }),
    ],
  }
).catch(err => console.error(err));
